import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {fetchAutocompleteData} from '@components/form/common/fetch';
import {Input} from '@components/form/Input';
const merge = require('deepmerge');

export default function RemoteAutocompleteWithInput(props) {
    const {
        onChange,
        disableClearable = false,
        groupBy = undefined,
        SearchString = '',
        searchFieldName,
        classWrapperName = '',
        initialValue = '',
        initOnRuntime = undefined,
        validateSearchInput = null,
        ...other
    } = props;

    const [loading, setLoading] = React.useState(false);
    const [searchQuery, setSearchQuery] = React.useState('');
    const [queryChanged, setQueryChanged] = React.useState(!initOnRuntime);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [errors, setErrors] = React.useState({});

    React.useEffect(() => {
        if (initialValue) {
            setSearchQuery(initialValue);
        }
    }, []);

    React.useEffect(() => {
        if (loading || !queryChanged) {
            return undefined;
        }

        (async () => {
            const {url, searchFieldName = 'query'} = props;

            setQueryChanged(false);
            setLoading(true);
            setErrors({});

            try {
                const urlObject = new URL(location.protocol+'//'+location.hostname
                    + (location.port.length > 0 ? ":" + location.port : "")
                    +url);
                urlObject.searchParams.set(searchFieldName, searchQuery);

                const data = await fetchAutocompleteData(urlObject.toString());

                if (typeof data === 'object' && Array.isArray(data.data)) {
                    setOptions(data.data);
                } else {
                    setErrors({[props.name]: ['Failed to fetch source data']});
                    setOpen(false);
                }
            } catch (e) {
                setOpen(false);
                setErrors({[props.name]: ['Failed to fetch source data']});
            }

            setLoading(false);
        })();
    }, [searchQuery, loading]);

    const totalErrors = merge(errors, props.errors || {});

    let filteredOptions = options.filter((row) => row.value == props.value);
    const optionValue = filteredOptions.length > 0
        ? filteredOptions[0]
        : {};

    const inputValue = optionValue.label
        ? optionValue.label
        : searchQuery


    return (
        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            value={optionValue}
            getOptionSelected={(option, value) => option.label === value.label}
            getOptionLabel={option => option.label || ''}
            onChange={(e, selected) => {
                setSearchQuery(selected ? selected.label : '');
                onChange(selected ? selected.value : '', selected);
            }}
            options={options}
            loading={loading}
            groupBy={groupBy}
            className={classWrapperName}
            renderInput={params => (
                <Input
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    {...other}
                    errors={totalErrors}
                />
            )}
            onInputChange={(e) => {
                if (!e || !e.target) {
                    return;
                }
                setSearchQuery(e.target.value);
                onChange(e.target.value);
            }}
            inputValue={inputValue}
            noOptionsText='Ничего не найдено'
        />
    );
}
